<template>
  <div :class="['price-override-container']">
    <v-icon v-if="useTransitionPeriodOverrideStyling" x-small class="transition-period-override"
      >fa fa-snowflake-o</v-icon
    >
    <div
      :class="{
        'price-value': true,
        'transition-period-override': useTransitionPeriodOverrideStyling,
      }"
    >
      {{ priceForDisplay }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import priceOverrideMixin from '../../mixins/priceOverride';
import { get } from 'lodash';
import { localisedFormatter } from '../../utils/inputs-grid-utils';
import overrideTypes from '@enums/override-types';

export default Vue.extend({
  name: 'PriceOverrideCellRenderer',

  mixins: [priceOverrideMixin],

  computed: {
    priceForDisplay() {
      const price = get(this.params.data, 'overridePrice.price', null);
      return localisedFormatter({ value: price });
    },
    useTransitionPeriodOverrideStyling() {
      return (
        get(this.params.data, 'overridePrice.overrideType', null) ===
          overrideTypes.transitionPeriod &&
        get(this.params.data, 'overridePrice.price', null) !== null
      );
    },
  },
});
</script>

<style scoped lang="scss">
@import '@style/base/_variables.scss';
.price-override-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 0 4px;
}

.price-value {
  flex: 1;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.transition-period-override {
  color: $grid-view-transition-period-override-color !important;
}
</style>
